module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-60x60-cb456e474da8b99b3a6ad60747590375.png";